import * as types from "../mutation-types";

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    // navigation links displayed on the left side of the page. they can be activated or disabled
    // based on the users permission
    // eg. this.$store.dispatch("uiPermissions/setNavItemState", {id:"home", active: false});
    // this doesn't prevent navigation to that page, it only hides the link
    navItems: [{
      id: "home",
      name: "Home",
      url: "/home",
      icon: "icon-home",
      active: true
    },
    {
      id: "users",
      name: "Users",
      url: "/users",
      icon: "flaticon-users",
      active: true,
      category: "configuration"
    },
    {
      id: "roles",
      name: "Roles",
      url: "/roles",
      icon: "flaticon-visible",
      active: true,
      category: "configuration"
    },
    {
      id: "permissions",
      name: "Permissions",
      url: "/permissions",
      icon: "flaticon-lock",
      active: true,
      category: "configuration"
    },
    {
      id: "tenants",
      name: "Tenants",
      url: "/tenants",
      icon: "flaticon-network",
      active: true,
      category: "configuration"
    },
    {
      id: "companies",
      name: "Companies",
      url: "/companies",
      icon: "flaticon-computer",
      active: true,
      category: "configuration"
    },
    {
      id: "products",
      name: "Products",
      url: "/products",
      icon: "flaticon-share",
      active: true,
      category: "configuration"
    },
    {
      id: "shops",
      name: "Shops",
      url: "/shops",
      icon: "flaticon-layers",
      active: true,
      category: "configuration"
    },
    {
      id: "shop-groups",
      name: "Shop Groups",
      url: "/shop-groups",
      icon: "flaticon-folder-1",
      active: true,
      category: "configuration"
    },
    {
      id: "banks",
      name: "Banks",
      url: "/banks",
      icon: "flaticon-piggy-bank",
      active: true,
      category: "configuration"
    },
    {
      id: "operators",
      name: "Cash Collectors",
      url: "/cash-collectors",
      icon: "flaticon-profile-1",
      active: true,
      category: "configuration"
    },
    {
      id: "subtypes",
      name: "Subtypes",
      url: "/subtypes",
      icon: "flaticon-web",
      active: true,
      category: "configuration"
    },
    {
      id: "slots",
      name: "Slots",
      url: "/slots",
      icon: "flaticon-car",
      active: true,
      category: "configuration"
    },
    {
      id: "backoffice",
      name: "Global Settings",
      url: "/backoffice",
      icon: "flaticon-settings",
      active: true,
      category: "configuration"
    },
    {
      id: "profile",
      name: "Profile",
      url: "/profile",
      icon: "flaticon-profile",
      active: true,
      category: "configuration"
    },
    {
      id: "devices",
      name: "Devices",
      url: "/devices",
      icon: "flaticon-imac",
      active: true,
      category: "configuration"
    },
    {
      id: "countries",
      name: "Lottery Countries",
      url: "/countries",
      icon: "flaticon-earth-globe",
      active: true,
      category: "products"
    },
    {
      id: "lottery-systems",
      name: "Lottery Systems",
      url: "/lottery-systems",
      icon: "flaticon-grid-menu-v2",
      active: true,
      category: "products"
    },
    {
      id: "lottery-events",
      name: "Lottery Events",
      url: "/lottery-events",
      icon: "flaticon-alarm",
      active: true,
      category: "products"
    },
    {
      id: "tickets",
      name: "Lottery Tickets",
      url: "/tickets",
      icon: "flaticon-edit-1",
      active: true,
      category: "products"
    },
    {
      id: "ticket-authorizations",
      name: "Ticket Authorizations",
      url: "/ticket-authorizations",
      icon: "flaticon-folder",
      active: true,
      category: "products"
    },
    {
      id: "firewalls",
      name: "Lottery Firewall Rulesets",
      url: "/firewalls",
      icon: "flaticon-globe",
      active: true,
      category: "products"
    },
    {
      id: "players",
      name: "Players",
      url: "/players",
      icon: "flaticon-user-ok",
      active: true,
      category: "products"
    },
    {
      id: "online-players",
      name: "Online Players",
      url: "/online-players",
      icon: "flaticon-user-ok",
      active: true,
      category: "products"
    },
    {
      id: "third-party-players",
      name: "Third Party Players",
      url: "/third-party-players",
      icon: "flaticon-user-ok",
      active: true,
      category: "products"
    },
    {
      id: "user-activity",
      name: "User Activity",
      url: "/user-activity",
      icon: "flaticon-user-settings",
      active: true,
      category: "platformReports"
    },
    {
      id: "user-clocking",
      name: "User Clocking",
      url: "/user-clocking",
      icon: "flaticon-stopwatch",
      active: true,
      category: "platformReports"
    },
    {
      id: "user-clocking-manual",
      name: "User Clocking (Manual)",
      url: "/user-clocking-manual",
      icon: "flaticon-stopwatch",
      active: true,
      category: "platformReports"
    },
    {
      id: "terminal-activity",
      name: "Terminal Activity",
      url: "/terminal-activity",
      icon: "flaticon-computer",
      active: true,
      category: "platformReports"
    },
    {
      id: "audits",
      name: "Audits",
      url: "/audits",
      icon: "flaticon-list",
      active: true,
      category: "platformReports"
    },
    {
      id: "cash-results",
      name: "Cash Results",
      url: "/cash-results",
      icon: "flaticon-file-2",
      active: true,
      category: "reports"
    },
    {
      id: "return-players",
      name: "Return to Players",
      url: "/return-players",
      icon: "flaticon-list-1",
      active: true,
      category: "reports"
    },
    {
      id: "taxed-paid-ticket",
      name: "Taxed Paid Tickets",
      url: "/taxed-paid-tickets",
      icon: "flaticon-list-2",
      active: true,
      category: "reports"
    },
    {
      id: "expired-winnings",
      name: "Expired Winnings",
      url: "/expired-winnings",
      icon: "flaticon-calendar-1",
      active: true,
      category: "reports"
    },
    {
      id: "lottery-offers",
      name: "Lottery Offers",
      url: "/lottery-offers",
      icon: "flaticon-interface-9",
      active: true,
      category: "reports"
    },
    {
      id: "lottery-results",
      name: "Lottery Results",
      url: "/lottery-results",
      icon: "flaticon-multimedia-5",
      active: true,
      category: "reports"
    },
    {
      id: "lottery-systems-performance",
      name: "Lottery Performance",
      url: "/lottery-systems-performance",
      icon: "flaticon-stopwatch",
      active: true,
      category: "reports"
    },
    {
      id: "shop-visits",
      name: "Shop Visits",
      url: "/shop-visits",
      icon: "flaticon-users",
      active: true,
      category: "reports"
    },
    {
      id: "income-payments",
      name: "Income - Payments",
      url: "/income-payments",
      icon: "flaticon-cart",
      active: true,
      category: "financialReports"
    },
    {
      id: "device-income-payments",
      name: "Terminal Income Reports",
      url: "/device-income-payments",
      icon: "flaticon-cart",
      active: true,
      category: "financialReports"
    },
    {
      id: "daily-monthly-income",
      name: "Daily/Monthly Income",
      url: "/daily-monthly-income",
      icon: "flaticon-graph",
      active: true,
      category: "financialReports"
    },
    {
      id: "cash-register",
      name: "Cash Register",
      url: "/cash-register",
      icon: "flaticon-interface-3",
      active: true,
      category: "financialReports"
    },
    {
      id: "income-winnings",
      name: "Income - Winnings",
      url: "/income-winnings",
      icon: "flaticon-list",
      active: true,
      category: "financialReports"
    },
    {
      id: "shop-balance",
      name: "Shop Balance",
      url: "/shop-balance",
      icon: "flaticon-coins",
      active: true,
      category: "financialReports"
    },
    {
      id: "cash-required",
      name: "Cash Required",
      url: "/cash-required",
      icon: "flaticon-alert-2",
      active: true,
      category: "financialReports"
    },
    {
      id: "cash-operations",
      name: "Cash Operations",
      url: "/cash-operations",
      icon: "flaticon-piggy-bank",
      active: true,
      category: "financialReports"
    },
    {
      id: "epos-operations",
      name: "EPOS Operations",
      url: "/epos-operations",
      icon: "flaticon-business",
      active: true,
      category: "financialReports"
    },
    {
      id: "online-cash-transactions",
      name: "Online Cash Transactions",
      url: "/online-cash-transactions",
      icon: "flaticon-bag",
      active: true,
      category: "financialReports"
    },
    {
      id: "api-imports",
      name: "API Imports",
      url: "/api-imports",
      icon: "flaticon-map",
      active: true,
      category: "financialReports"
    },
    {
      id: "manual-report",
      name: "Add Manual Report",
      url: "/manual-report",
      icon: "flaticon-edit-1",
      active: true,
      category: "financialReports"
    },
    {
      id: "recompute-shop-balance",
      name: "Recompute Shop Balance",
      url: "/recompute-shop-balance",
      icon: "flaticon-clipboard",
      active: true,
      category: "admin"
    },
    {
      id: "operators-report",
      name: "Operators Report",
      url: "/operators-report",
      icon: "flaticon-customer",
      active: true,
      category: "financialReports"
    },
    {
      id: "online-payouts",
      name: "Online Payouts",
      url: "/online-payouts",
      icon: "flaticon-calendar-1",
      active: true,
      category: "financialReports"
    },
    {
      id: "jackpots",
      name: "Jackpots",
      url: "/jackpots",
      icon: "icon-diamond",
      active: true,
      category: "jackpots"
    },
    {
      id: "jackpots-history",
      name: "History of Jackpots Won",
      url: "/jackpots-history",
      icon: "icon-chart",
      active: true,
      category: "jackpots"
    },
    {
      id: "raffle",
      name: "Raffle Clients",
      url: "/raffle",
      icon: "icon-chart",
      active: true,
      category: "jackpots"
    },
    {
      id: "raffle-serials",
      name: "Raffle Serials",
      url: "/raffle-serials",
      icon: "icon-chart",
      active: true,
      category: "jackpots"
    },
    ],

    // access rules
    rules: [],
  },
  // -----------------------------------------------------------------
  getters: {
    navItems: state => state.navItems,
    getNavItemByID: state => id => {
      for (const item of state.navItems) {
        if (item.id === id) {
          return item;
        }
      }
    }
  },
  // -----------------------------------------------------------------
  mutations: {
    [types.UPDATE_NAV_ITEM_STATE]: (state, params) => {
      for (const item of state.navItems) {
        if (item.id === params.id) {
          item.active = params.active;
          return;
        }
      }
    },
    [types.LOAD_RULES]: (state, params) => {
      state.rules = params.rules;
    },
    [types.DESTROY_RULES]: (state, params) => {
      state.rules = [];
    }
  },
  // -----------------------------------------------------------------
  actions: {
    setNavItemState: (context, params) => {
      context.commit(types.UPDATE_NAV_ITEM_STATE, params);
    },
    loadRules: (context, params) => {
      context.commit(types.LOAD_RULES, params);
    },
    destroyRules: (context, params) => {
      context.commit(types.DESTROY_RULES, params);
    },
  }
};
